import { Component, inject } from '@angular/core';
import { ThemeService } from 'rev-portal/branding/Theme.Service';

import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';

@Component({
	selector: 'branding-banner-image',
	templateUrl: './BrandingBannerImage.Component.html',
	styleUrl: './branding-banner-image.ng.less',
	imports: [DirectivesAngularModule]
})
export class BrandingBannerImageComponent {
	public readonly ThemeService = inject(ThemeService);
}
